export const portalSortFieldTypes: PortalSortField[] = [
  'memberCount',
  'name',
  'contentCount',
];

export type PortalSortField = 'memberCount' | 'name' | 'contentCount';
